import { isNil } from 'lodash';

export const getTrialFormattedPrice = (price: number, currency: string, isTrialFree?: boolean) => {
  if (isNil(price)) {
    return '';
  }

  if (isTrialFree) {
    if (currency === 'EUR') {
      return '€0.00';
    }
    return 'FREE';
  }
  if (currency === 'USD') {
    return `$${price / 100}`;
  }

  if (currency === 'BRL') {
    return `R$${price / 100}`;
  }

  if (currency === 'MXN') {
    return `MXN$ ${price / 100}`;
  }

  if (currency === 'GBP') {
    return `£${price / 100}`;
  }

  if (currency === 'PLN') {
    return `zł${price / 100}`;
  }

  if (currency === 'JPY') {
    if (price === 4500000) {
      return `${price / 100}円`;
    }
    return `${price / 100}円`;
  }

  if (currency === 'TRY') {
    return `${price / 100}₺`;
  }

  return `€${price / 100}`;
};

export const getAnnualFormattedPrice = (price: number, currency: string, isFullPriceShown: boolean) => {
  if (isNil(price)) {
    return '';
  }

  if (isFullPriceShown) {
    if (currency === 'USD') {
      return `$${price / 100}`;
    }

    if (currency === 'BRL') {
      return `R$${price / 100}`;
    }

    if (currency === 'MXN') {
      return `MXN$ ${price / 100}`;
    }

    if (currency === 'GBP') {
      return `£${price / 100}`;
    }

    if (currency === 'PLN') {
      return `zł${price / 100}`;
    }

    if (currency === 'JPY') {
      return `${price / 100}円`;
    }
    if (currency === 'TRY') {
      return `${price / 100}₺`;
    }

    return `€${price / 100}`;
  }

  if (price === 23900 && currency === 'EUR') {
    return '€19.99';
  }
  if (price === 23900 && currency === 'USD') {
    return '$19.99';
  }

  if (price === 19900) {
    // return `€${price/100/12}`
    return '€16.67';
  }
  if (price === 15900) {
    return `$${price / 100 / 12}`;
  }
  if (currency === 'USD') {
    // return `$${price/100/12}`
    return '$24.95';
  }

  if (currency === 'BRL') {
    return `R$69`;
  }

  if (currency === 'MXN') {
    return `MXN$ 399`;
  }

  if (currency === 'GBP') {
    // return `$${price/100/12}`
    return '£24.95';
  }

  if (currency === 'PLN') {
    return `zł99.91`;
  }

  if (currency === 'JPY') {
    return `${price / 100 / 12}円`;
  }

  if (currency === 'TRY') {
    return `${Math.floor(price / 100 / 12)}₺`;
  }
  // return `€${price/100/12}`
  return '€24.95';
};

export const getCurrency = (currency: string) => {
  if (currency === 'USD') {
    return '$';
  }

  if (currency === 'BRL') {
    return 'R$';
  }

  if (currency === 'MXN') {
    return 'MXN$';
  }

  if (currency === 'GBP') {
    return '£';
  }

  if (currency === 'PLN') {
    return `zł`;
  }

  if (currency === 'JPY') {
    return `円`;
  }

  if (currency === 'TRY') {
    return '₺';
  }

  return '€';
};

export const getCancelledPriceRemarketing = (price: number, currency: string) => {
  if (isNil(price)) {
    return '';
  }

  if (price === 2499) {
    if (currency === 'USD') {
      return `$49.99`;
    }

    if (currency === 'GBP') {
      return '£49.99';
    }

    return `€49.99`;
  }

  if (currency === 'USD') {
    return `$34.99`;
  }

  if (currency === 'PLN') {
    return `zł34.99`;
  }

  if (currency === 'GBP') {
    return '£34.99';
  }

  return `€34.99`;
};
